var render = function render(){var _vm=this,_c=_vm._self._c;return _c('awards-list',{attrs:{"awards":_vm.mappedAwards,"can-award-emoji":_vm.canAwardEmoji,"current-user-id":_vm.currentUserData.id,"default-awards":_vm.$options.defaultAwards},on:{"award":_vm.handleAward}})
}
var staticRenderFns = []

export { render, staticRenderFns }